import _extends from "@babel/runtime/helpers/extends";
import { Modal } from '@wix/design-system';
import { packagePickerTranslationsExtension, useFormatPrice as useP3FormatPrice } from '@wix/package-picker-shared';
import { ApisClientProvider } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createPremiumModule, modalsExtension } from '@wix/premium-fed-sdk/@premium-module';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { SwitchExtension } from '../../extensions';
import { DowngradeErrorModal } from './components/DowngradeErrorModal/DowngradeErrorModal';
import { DowngradeModal } from './components/DowngradeModal/DowngradeModal';
import { DowngradeSuccessModal } from './components/DowngradeSuccessModal/DowngradeSuccessModal';
import { PlanFeaturesModal } from './components/PlanFeaturesModal/PlanFeaturesModal';
import { SwitchProductModuleContextExtension } from './context.extension';
import { useProductAvailability, useProductDowngradeData, useSwitchFlows } from './hooks';
export const SwitchProductModule = createPremiumModule('switch-product-module', [SwitchProductModuleContextExtension, packagePickerTranslationsExtension, SwitchExtension, modalsExtension({
  DowngradeModal: _ref => {
    let {
      productId,
      callbacks,
      ...modalProps
    } = _ref;
    return /*#__PURE__*/React.createElement(Modal, _extends({
      shouldCloseOnOverlayClick: true
    }, modalProps), /*#__PURE__*/React.createElement(DowngradeModal, {
      targetProductId: productId,
      callbacks: callbacks,
      isOpen: modalProps.isOpen
    }));
  },
  DowngradeSuccessModal: _ref2 => {
    let {
      callbacks,
      ...modalProps
    } = _ref2;
    return /*#__PURE__*/React.createElement(Modal, _extends({
      shouldCloseOnOverlayClick: true
    }, modalProps), /*#__PURE__*/React.createElement(DowngradeSuccessModal, {
      callbacks: callbacks
    }));
  },
  DowngradeErrorModal: _ref3 => {
    let {
      callbacks,
      error,
      errorType,
      ...modalProps
    } = _ref3;
    return /*#__PURE__*/React.createElement(Modal, _extends({
      shouldCloseOnOverlayClick: true
    }, modalProps), /*#__PURE__*/React.createElement(DowngradeErrorModal, {
      callbacks: callbacks,
      error: error,
      errorType: errorType
    }));
  },
  PlanFeaturesModal: props => {
    const {
      onClose,
      onShow,
      ...modalProps
    } = props;
    return /*#__PURE__*/React.createElement(Modal, _extends({
      shouldCloseOnOverlayClick: true
    }, modalProps), /*#__PURE__*/React.createElement(PlanFeaturesModal, {
      onClose: props.onClose,
      onShow: props.onShow
    }));
  }
})], module => {
  return {
    Provider: _ref4 => {
      let {
        children
      } = _ref4;
      const {
        p3Context
      } = module.internals.useContext();
      module.SDK.switchContext.set('p3Context', p3Context);
      const content = /*#__PURE__*/React.createElement(ApisClientProvider, null, /*#__PURE__*/React.createElement(module.SDK.Modals, null), children);
      if (p3Context) {
        return /*#__PURE__*/React.createElement(PremiumPurchasePlatformModule.Provider, {
          translations: {
            Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
          },
          context: p3Context
        }, content);
      }
      return content;
    },
    SDK: {
      ...module.SDK,
      modalsController: module.internals.modalsController,
      SwitchExtension,
      useFormatPrice: useP3FormatPrice,
      hooks: {
        useProductDowngradeData,
        useProductAvailability,
        useSwitchFlows
      }
    }
  };
});
//# sourceMappingURL=switch-product.module.js.map